import {useTranslation} from "react-i18next";
import type {DibDocument} from "../types";
import classes from "./SupplierInfoLEGACY.module.css";

const dateFormatter = new Intl.DateTimeFormat("nb-NO", {
    year: "numeric",
    month: "long",
    day: "numeric",
});

const formatDate = (iso: string | undefined) => {
    if (!iso) return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return dateFormatter.format(d);
};

export const SupplierInfoLEGACY = ({
    document: doc,
}: {
    document: DibDocument;
}) => {
    const {t} = useTranslation();
    if (!doc.supplier || doc.supplier === "DIBkunnskap") return null;
    const formatted = formatDate(doc.date);

    return (
        <section className={classes.section}>
            <h2 className={classes.heading}>
                {t("Word.Info", {defaultValue: "info"})?.toLowerCase()}
            </h2>
            <div className={classes.name}>{doc.supplier}</div>
            {formatted && (
                <time className={classes.date} dateTime={doc.date}>
                    {formatted}
                </time>
            )}
        </section>
    );
};
